import React from 'react';

import Text from '~/components/core/TextComponents/Text';

export const ReviewSection: React.FC<{ heading?: string; children: React.ReactNode }> = ({ heading, children }) => (
  <section className="flex flex-col gap-8 rounded-lg border border-solid border-slate-300 px-16 py-12">
    {heading ? (
      <Text variant={Text.VARIANTS.XS} weight={Text.WEIGHTS.SEMI_BOLD} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        {heading}
      </Text>
    ) : null}
    {children}
  </section>
);
